import * as tslib_1 from "tslib";
import { ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { AviationEvent, AviationEventTypeDesc } from '../../shared/models/aviation-event.model';
import { MatSnackBar } from '@angular/material';
import * as MomentTZ from 'moment-timezone';
import { eventAMPM, eventCanadianProvinces, eventCountries, eventHours, eventMinutes, eventUSStates, LOCAL_TZ } from '../../globals';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
import { AirportService } from '../../airport/airport.service';
import { LatLon } from '../../util/geodesy/latlon';
import { GoogleService } from '../../google/google.service';
import { UserService } from '../../shared/user/user.service';
import { Router } from '@angular/router';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { GoogleMapsValidationModel } from '../../google/google-maps-validation.model';
import { AddressValidationService } from '../../google/address-validation.service';
var Granularity = GoogleMapsValidationModel.Granularity;
var TimeZones;
(function (TimeZones) {
    TimeZones["ATLANTIC"] = "America/Halifax";
    TimeZones["EASTERN"] = "America/New_York";
    TimeZones["CENTRAL"] = "America/Chicago";
    TimeZones["MOUNTAIN"] = "America/Denver";
    TimeZones["PACIFIC"] = "America/Los_Angeles";
    TimeZones["HAWAII"] = "Pacific/Honolulu";
    TimeZones["ALASKA"] = "America/Anchorage";
})(TimeZones || (TimeZones = {}));
var USTimezones = [
    { id: 1, countryCode: 'America/Halifax', zoneName: 'ATLANTIC' },
    { id: 2, countryCode: 'America/New_York', zoneName: 'EASTERN' },
    { id: 3, countryCode: 'America/Chicago', zoneName: 'CENTRAL' },
    { id: 4, countryCode: 'America/Denver', zoneName: 'MOUNTAIN' },
    { id: 5, countryCode: 'America/Los_Angeles', zoneName: 'PACIFIC' },
    { id: 6, countryCode: 'Pacific/Honolulu', zoneName: 'HAWAII' },
    { id: 7, countryCode: 'America/Anchorage', zoneName: 'ALASKA' }
];
var EventAddFormComponent = /** @class */ (function () {
    function EventAddFormComponent(_fb, _aviationEventsService, _airportService, _snackBar, _googleService, _userService, _router, _businessManagerService, _addressValidationService) {
        this._fb = _fb;
        this._aviationEventsService = _aviationEventsService;
        this._airportService = _airportService;
        this._snackBar = _snackBar;
        this._googleService = _googleService;
        this._userService = _userService;
        this._router = _router;
        this._businessManagerService = _businessManagerService;
        this._addressValidationService = _addressValidationService;
        this.shortEventDescCharCount = 0;
        this.shortEventDescMaxChars = 200;
        this.eventFormats = ['Online', 'In-Person', 'Both'];
        this.timeZones = Object.keys(TimeZones).sort();
        this.eventCountries = eventCountries;
        // tslint:disable-next-line:max-line-length
        this.urlRegex = /^((https?|http):\/\/)?(([a-z\d]([a-z\d-]*[a-z\d])?\.)+[a-z]{2,}|localhost)(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
        this.startDateMin = new Date();
        this.endDateMin = this.startDateMin;
        this.airports = [];
        this.selectedAirport = null;
        this.airportSelectionError = false;
        this.showAddressFields = true;
        this.isFlightDeckAdmin = false;
        this.isSaving = false;
        this.eventHours = eventHours;
        this.eventMinutes = eventMinutes;
        this.eventAMPM = eventAMPM;
        this.currentCountry = 'United States';
    }
    EventAddFormComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var localOffset, currentTimeZone, currentTimeZoneSimpleName, _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        localOffset = MomentTZ().tz(LOCAL_TZ).utcOffset();
                        currentTimeZone = Object.values(TimeZones).filter(function (it) { return MomentTZ().tz(it).utcOffset() === localOffset; }).pop();
                        currentTimeZoneSimpleName = Object.keys(TimeZones).filter(function (it) { return TimeZones[it] === currentTimeZone; }).pop();
                        this.eventTypes = Object.values(AviationEventTypeDesc);
                        this._userInfo = this._userService.userInfo.getValue();
                        this._businessManagerService.isFlightDeckAdmin().then(function (isAdmin) { return _this.isFlightDeckAdmin = isAdmin; });
                        if (this._userInfo) {
                            this.recId = Number(this._userInfo.masterCustomerId);
                        }
                        this._userService.userInfo.subscribe(function (u) {
                            // Update userInfo
                            _this._userInfo = u;
                            if (u) {
                                _this.recId = Number(u.masterCustomerId);
                            }
                        });
                        this.addEventForm = this._fb.group({
                            title: ['', Validators.required],
                            shortDescription: ['', Validators.required],
                            description: ['', Validators.required],
                            type: ['', Validators.required],
                            format: ['', Validators.required],
                            webinarRegistrationLink: [null, Validators.pattern(this.urlRegex)],
                            informationWebsite: [null, Validators.pattern(this.urlRegex)],
                            websiteCustomLabel: ['', Validators.nullValidator],
                            cost: ['', Validators.nullValidator],
                            coverPhoto: ['', [this.requiredFileType(['jpg', 'png', 'jpeg', 'gif'])]],
                            additionalPhoto1: [{ value: '', disabled: true }, [this.requiredFileType(['jpg', 'png', 'jpeg', 'gif'])]],
                            additionalPhoto2: [{ value: '', disabled: true }, [this.requiredFileType(['jpg', 'png', 'jpeg', 'gif'])]],
                            startDate: ['', Validators.required],
                            endDate: ['', Validators.required],
                            startHour: ['', Validators.required],
                            startMin: ['', Validators.required],
                            startAMPM: ['', Validators.required],
                            endHour: ['', Validators.required],
                            endMin: ['', Validators.required],
                            endAMPM: ['', Validators.required],
                            timezone: ['', Validators.required],
                            venueLocationName: ['', Validators.required],
                            address1: ['', Validators.required],
                            address2: ['', Validators.nullValidator],
                            address3: ['', Validators.nullValidator],
                            city: ['', Validators.required],
                            isOnAirport: [false, Validators.nullValidator],
                            airport: ['', Validators.nullValidator],
                            stateProvince: ['', Validators.required],
                            zipcode: ['', Validators.required],
                            country: ['US', Validators.required],
                            internationalAirportId: ['', Validators.nullValidator],
                            internationalAirportName: ['', Validators.nullValidator],
                            contactPersonName: ['', Validators.required],
                            contactPersonEmail: ['', Validators.required],
                            contactPersonPhone: ['', Validators.required],
                            isValidated: ['', Validators.nullValidator],
                            isFeatured: ['', Validators.nullValidator],
                            hasAopaPresence: ['', Validators.nullValidator],
                            isAopaHosted: ['', Validators.nullValidator],
                            latitude: ['', [Validators.min(-90), Validators.max(90), Validators.pattern('^-?\\d+[.]\\d+$')]],
                            longitude: ['', [Validators.min(-180), Validators.max(180), Validators.pattern('^-?\\d+[.]\\d+$')]],
                            overrideAddressLookup: [false, Validators.nullValidator]
                        }, { updateOn: 'submit' });
                        _a = this;
                        return [4 /*yield*/, this._aviationEventsService.getCountries()];
                    case 1:
                        _a.countries = _b.sent();
                        return [4 /*yield*/, this.updateTimeZones('US')];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EventAddFormComponent.prototype.buildZonedTime = function (date, time, timezone) {
        var month = ('0' + (date.getMonth() + 1)).slice(-2);
        var day = ('0' + date.getDate()).slice(-2);
        var year = date.getFullYear();
        var localTime = MomentTZ.tz(year + "-" + month + "-" + day + " " + time, timezone);
        return localTime.utc().format('MM/DD/YYYY h:mm:ss A');
    };
    EventAddFormComponent.prototype.onSubmit = function (form) {
        var _this = this;
        var formValue = this.addEventForm.value;
        var eventURL = 'event/';
        if (formValue.airport.trim() && this.selectedAirport == null) {
            this.airportSelectionError = true;
            this._snackBar.open('Invalid Airport Selected', null, { duration: 3000 });
            return;
        }
        else if (this.addEventForm.invalid) {
            this._snackBar.open('Form field validation failed. check form values', null, { duration: 3000 });
            return;
        }
        else if (this.photoIsTooLarge('coverPhoto')) {
            this._snackBar.open('Cover Photo/Thumbnail file is too Large: File must be below 10MB', null, { duration: 5000 });
            return;
        }
        else if (this.photoIsTooLarge('additionalPhoto1')) {
            this._snackBar.open('Additional Photo 1 file is too Large: File must be below 10MB', null, { duration: 5000 });
            return;
        }
        else if (this.photoIsTooLarge('additionalPhoto2')) {
            this._snackBar.open('Additional Photo 2 file is too Large: File must be below 10MB', null, { duration: 5000 });
            return;
        }
        else if (this.showDateError()) {
            this._snackBar.open('start time cannot be after end time, check end time is not before start time', null, { duration: 3000 });
            return;
        }
        this.isSaving = true;
        this._getAviationEventFromFormValue(formValue)
            .then(function (event) { return _this._aviationEventsService.addAviationEvent(event); })
            .then(function (data) {
            if (_this.eventCoverImage) {
                _this._aviationEventsService.uploadEventCoverImg(_this.eventCoverImage, data.eventId).then(function (photoRes) {
                    if (_this.additionalPhoto1) {
                        _this._aviationEventsService.uploadEventCoverImg(_this.additionalPhoto1, data.eventId).then(function (photoRes1) {
                            if (_this.additionalPhoto2) {
                                _this._aviationEventsService.uploadEventCoverImg(_this.additionalPhoto2, data.eventId).then(function (photoRes2) {
                                    _this.isSaving = false;
                                    return _this._router.navigateByUrl(eventURL + data.eventId);
                                });
                            }
                            else {
                                _this.isSaving = false;
                                return _this._router.navigateByUrl(eventURL + data.eventId);
                            }
                        });
                    }
                    else {
                        _this.isSaving = false;
                        return _this._router.navigateByUrl(eventURL + data.eventId);
                    }
                });
            }
            else {
                _this.isSaving = false;
                return _this._router.navigateByUrl(eventURL + data.eventId);
            }
        }).catch(function (err) {
            console.error(err);
            _this.isSaving = false;
        });
    };
    /* public isGooglePlacesCountry(): boolean {
      if (this.addEventForm.value.country && eventGoogleCountries.includes(this.addEventForm.value.country)) {
        return true;
      }
      return false;
    } */
    EventAddFormComponent.prototype.isUSorCA = function () {
        if (this.addEventForm.value.country && ['US', 'CA'].includes(this.addEventForm.value.country)) {
            return true;
        }
        return false;
    };
    EventAddFormComponent.prototype.showLatLng = function () {
        return !this.isUSorCA() || (this.isFlightDeckAdmin && !!this.addEventForm.value.overrideAddressLookup);
    };
    EventAddFormComponent.prototype._getRegionCodeFromCountry = function (country) {
        switch (country.toLowerCase()) {
            /* case 'argentina':
              return 'AR';
            case 'austria':
              return 'AT';
            case 'australia':
              return 'AU';
            case 'belgium':
              return 'BE';
            case 'bulgaria':
              return 'BG';
            case 'brazil':
              return 'BR';
            case 'switzerland':
              return 'CH';
            case 'chile':
              return 'CL';
            case 'colombia':
              return 'CO';
            case 'czechia':
              return 'CZ';
            case 'germany':
              return 'DE';
            case 'denmark':
              return 'DK';
            case 'estonia':
              return 'EE';
            case 'spain':
              return 'ES';
            case 'finland':
              return 'FI';
            case 'france':
              return 'FR';
            case 'united kingdom':
              return 'GB';
            case 'croatia':
              return 'HR';
            case 'hungary':
              return 'HU';
            case 'ireland':
              return 'IE';
            case 'india':
              return 'IN';
            case 'italy':
              return 'IT';
            case 'lithuania':
              return 'LT';
            case 'luxembourg':
              return 'LU';
            case 'latvia':
              return 'LV';
            case 'mexico':
              return 'MX';
            case 'Malaysia':
              return 'MY';
            case 'netherlands':
              return 'NL';
            case 'norway':
              return 'NO';
            case 'new zealand':
              return 'NZ';
            case 'poland':
              return 'PL';
            case 'puerto rico':
              return 'PR';
            case 'portugal':
              return 'PT';
            case 'sweden':
              return 'SE';
            case 'singapore':
              return 'SG';
            case 'slovenia':
              return 'SI';
            case 'slovakia':
              return 'SK'; */
            case 'us':
                return 'US';
            case 'ca':
                return 'CA';
            default:
                return null;
        }
    };
    EventAddFormComponent.prototype._getAviationEventFromFormValue = function (formValue) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var aviationEvent, tzName, startDate, startTime, endDate, endTime, postalAddress, regionCode, validationResponse, result, verdict, granularityIsCorrect, address, location_1, errorMsg;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        aviationEvent = new AviationEvent();
                        tzName = formValue.timezone;
                        if (formValue.country === 'US') {
                            tzName = USTimezones.find(function (i) { return i.zoneName === formValue.timezone; }).countryCode;
                        }
                        startDate = new Date(formValue.startDate);
                        startTime = +formValue.startHour < 10 ? '0' + formValue.startHour : formValue.startHour;
                        // if startTime is 12:00 AM, set to 00:00
                        if (+formValue.startHour === 12 && formValue.startAMPM === 'AM') {
                            startTime = '00';
                        }
                        else {
                            startTime = formValue.startAMPM === 'PM' && +formValue.startHour < 12 ? (+startTime + 12).toString() :
                                startTime;
                        }
                        startTime = startTime + ':' + formValue.startMin;
                        endDate = new Date(formValue.endDate);
                        endTime = +formValue.endHour < 10 ? '0' + formValue.endHour : formValue.endHour;
                        // if endTime is 12:00 AM, set to 00:00
                        if (+formValue.endHour === 12 && formValue.endAMPM === 'AM') {
                            endTime = '00';
                        }
                        else {
                            endTime = formValue.endAMPM === 'PM' && +formValue.endHour < 12 ? (+endTime + 12).toString() : endTime;
                        }
                        endTime = endTime + ':' + formValue.endMin;
                        postalAddress = null;
                        regionCode = this._getRegionCodeFromCountry(formValue.country);
                        aviationEvent.recid = this.recId;
                        aviationEvent.title = formValue.title;
                        aviationEvent.shortDescription = formValue.shortDescription;
                        aviationEvent.description = formValue.description;
                        aviationEvent.type = AviationEvent.parseEventFromString(formValue.type);
                        aviationEvent.typeId = aviationEvent.type;
                        aviationEvent.webinarRegistrationLink = formValue.webinarRegistrationLink;
                        aviationEvent.websiteCustomLabel = formValue.websiteCustomLabel;
                        aviationEvent.cost = formValue.cost && formValue.cost.trim() ? formValue.cost.trim() : null;
                        aviationEvent.timezone = tzName;
                        aviationEvent.startDateTimeUTC = this.buildZonedTime(startDate, startTime, tzName);
                        aviationEvent.endDateTimeUTC = this.buildZonedTime(endDate, endTime, tzName);
                        aviationEvent.venueLocationName = formValue.venueLocationName;
                        aviationEvent.address1 = formValue.address1;
                        aviationEvent.address2 = formValue.address2 && formValue.address2.trim();
                        aviationEvent.address3 = formValue.address3 && formValue.address3.trim();
                        aviationEvent.city = formValue.city;
                        aviationEvent.stateProvince = formValue.stateProvince;
                        aviationEvent.zipcode = formValue.zipcode;
                        aviationEvent.country = this.currentCountry;
                        aviationEvent.countryCode = formValue.country;
                        aviationEvent.airportId = this.selectedAirport ? this.selectedAirport.airportId : null;
                        aviationEvent.contactPersonName = formValue.contactPersonName;
                        aviationEvent.contactPersonEmail = formValue.contactPersonEmail;
                        aviationEvent.contactPersonPhone = formValue.contactPersonPhone;
                        aviationEvent.isValidated = formValue.isValidated || false;
                        aviationEvent.isFeatured = formValue.isFeatured || false;
                        aviationEvent.hasAopaPresence = formValue.hasAopaPresence || false;
                        aviationEvent.isAopaHosted = formValue.isAopaHosted || false;
                        aviationEvent.isVisible = true;
                        aviationEvent.format = formValue.format;
                        aviationEvent.informationWebsite = formValue.informationWebsite;
                        aviationEvent.internationalAirportId = formValue.internationalAirportId;
                        aviationEvent.internationalAirportName = formValue.internationalAirportName;
                        if (!(regionCode && formValue.address1 && formValue.city && formValue.stateProvince && formValue.zipcode && formValue.country
                            && !formValue.overrideAddressLookup)) return [3 /*break*/, 2];
                        // US and Canada addresses
                        postalAddress = {
                            regionCode: regionCode,
                            languageCode: 'EN',
                            postalCode: aviationEvent.zipcode,
                            locality: aviationEvent.city,
                            addressLines: [aviationEvent.address1],
                        };
                        return [4 /*yield*/, this._addressValidationService
                                .checkAddress(new GoogleMapsValidationModel.RequestBody(postalAddress))];
                    case 1:
                        validationResponse = _a.sent();
                        result = validationResponse.result;
                        verdict = result.verdict;
                        granularityIsCorrect = verdict.geocodeGranularity === Granularity.PREMISE ||
                            verdict.geocodeGranularity === Granularity.SUB_PREMISE;
                        if (!verdict) {
                            return [2 /*return*/, aviationEvent];
                        }
                        if (granularityIsCorrect && !verdict.hasUnconfirmedComponents) {
                            address = result.address.postalAddress;
                            if (regionCode === 'US' || regionCode === 'CA') {
                                aviationEvent.city = address.locality;
                                aviationEvent.zipcode = address.postalCode.split('-')[0];
                                aviationEvent.address1 = address.addressLines[0];
                                aviationEvent.stateProvince = address.administrativeArea;
                            }
                            else {
                                aviationEvent.address1 = address.addressLines[0];
                                if (address.addressLines.length > 1) {
                                    aviationEvent.address2 = address.addressLines[1];
                                }
                                if (address.addressLines.length > 2) {
                                    aviationEvent.address3 = address.addressLines[2];
                                }
                                if (address.locality) {
                                    aviationEvent.city = address.locality;
                                }
                                if (address.postalCode) {
                                    aviationEvent.zipcode = address.postalCode;
                                }
                            }
                            location_1 = result.geocode && result.geocode.location ?
                                result.geocode.location : null;
                            aviationEvent.location = new LatLon(location_1.latitude, location_1.longitude);
                            aviationEvent.latitude = location_1.latitude;
                            aviationEvent.longitude = location_1.longitude;
                        }
                        else {
                            errorMsg = 'Invalid Address Enter a Correct Address';
                            if (verdict.hasUnconfirmedComponents && result.address.missingComponentTypes) {
                                this._snackBar
                                    .open(errorMsg + ", check: " + result.address.missingComponentTypes.join(', '), null, { duration: 10000 });
                            }
                            else {
                                this._snackBar.open(errorMsg, null, { duration: 10000 });
                            }
                            throw new Error('Invalid Address');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        // International addresses that Google doesn't support
                        // aviationEvent.city = address.locality;
                        // aviationEvent.zipcode = address.postalCode.split('-')[0];
                        aviationEvent.address1 = formValue.address1;
                        aviationEvent.address2 = formValue.address2;
                        aviationEvent.address3 = formValue.address3;
                        aviationEvent.location = new LatLon(formValue.latitude, formValue.longitude);
                        aviationEvent.latitude = formValue.latitude;
                        aviationEvent.longitude = formValue.longitude;
                        _a.label = 3;
                    case 3: return [2 /*return*/, aviationEvent];
                }
            });
        });
    };
    EventAddFormComponent.prototype.eventDateChange = function (type, event) {
        var element = event.targetElement;
        if (element.getAttribute('name') === 'startDate') {
            this.endDateMin = event.value;
        }
    };
    EventAddFormComponent.prototype.webinarRegistrationKeyUp = function (event) {
        var val = event.target.value;
        if (val.length < 3) {
            return;
        }
        this.addEventForm.get('webinarRegistrationLink').setValue(val.trim());
    };
    EventAddFormComponent.prototype.informationWebsiteKeyUP = function (event) {
        var val = event.target.value;
        if (val.length < 3) {
            return;
        }
        this.addEventForm.get('informationWebsite').setValue(val.trim());
    };
    EventAddFormComponent.prototype.airportQueryKeyUp = function (event) {
        var _this = this;
        var val = event.target.value;
        if (val.length < 3) {
            if (!val || val.length === 0) {
                this.airportSelectionError = false;
                this.selectedAirport = null;
                this.airports = [];
            }
            return;
        }
        this._airportService.getAirportsBySearchTerm(val, true).then(function (res) {
            _this.airports = res;
        }).catch(function (err) { return console.error(err); });
    };
    EventAddFormComponent.prototype.cancelButtonClicked = function (event) {
        this._router.navigate(['/'], { queryParams: { 't': 'events' } });
    };
    EventAddFormComponent.prototype.onPhotoCoverChange = function (event) {
        if (event.target.files && event.target.files.length) {
            this.eventCoverImage = event.target.files[0];
            this.addEventForm.controls['additionalPhoto1'].enable();
        }
        else {
            this.eventCoverImage = null;
            this.additionalPhoto1 = null;
            this.addEventForm.controls['additionalPhoto1'].disable();
            this.additionalPhoto1Input.nativeElement.value = '';
            this.additionalPhoto2 = null;
            this.addEventForm.controls['additionalPhoto2'].disable();
            this.additionalPhoto2Input.nativeElement.value = '';
        }
    };
    EventAddFormComponent.prototype.onAdditionalPhoto1Change = function (event) {
        if (event.target.files && event.target.files.length) {
            this.additionalPhoto1 = event.target.files[0];
            this.addEventForm.controls['additionalPhoto2'].enable();
        }
        else {
            this.additionalPhoto1 = null;
            this.additionalPhoto2 = null;
            this.addEventForm.controls['additionalPhoto2'].disable();
            this.additionalPhoto2Input.nativeElement.value = '';
        }
    };
    EventAddFormComponent.prototype.onAdditionalPhoto2Change = function (event) {
        if (event.target.files && event.target.files.length) {
            this.additionalPhoto2 = event.target.files[0];
        }
        else {
            this.additionalPhoto2 = null;
        }
    };
    EventAddFormComponent.prototype.photoIsTooLarge = function (photoType) {
        if (photoType === 'additionalPhoto1') {
            return this.additionalPhoto1 && this.additionalPhoto1.size > 10000000;
        }
        else if (photoType === 'additionalPhoto2') {
            return this.additionalPhoto2 && this.additionalPhoto2.size > 10000000;
        }
        else {
            return this.eventCoverImage && this.eventCoverImage.size > 10000000;
        }
    };
    EventAddFormComponent.prototype.hasInvalidFileType = function (photoType) {
        return this.addEventForm.get(photoType).hasError('requiredFileType');
    };
    EventAddFormComponent.prototype.showDateError = function () {
        var startDate = this.addEventForm.value.startDate;
        var endDate = this.addEventForm.value.endDate;
        var startHour = +this.addEventForm.value.startHour;
        if (startHour === 12) {
            startHour = 0;
        }
        startHour = this.addEventForm.value.startAMPM === 'PM' ? startHour + 12 : startHour;
        var endHour = +this.addEventForm.value.endHour;
        if (endHour === 12) {
            endHour = 0;
        }
        endHour = this.addEventForm.value.endAMPM === 'PM' ? endHour + 12 : endHour;
        var dateBoolean = startDate && endDate && startDate.getTime() > endDate.getTime();
        if (startDate && endDate && startDate.getTime() === endDate.getTime()) {
            return startHour > endHour || (startHour === endHour && +this.addEventForm.value.startMin > +this.addEventForm.value.endMin);
        }
        return dateBoolean;
    };
    EventAddFormComponent.prototype.requiredFileType = function (types) {
        return function (control) {
            var fileName = control.value;
            if (fileName) {
                var extension_1 = fileName.split('.').pop().toLowerCase();
                var hasExtension_1 = false;
                types.forEach(function (it) {
                    if (it.toLowerCase() === extension_1.toLowerCase()) {
                        hasExtension_1 = true;
                        return;
                    }
                });
                if (!hasExtension_1) {
                    return {
                        requiredFileType: true
                    };
                }
            }
        };
    };
    EventAddFormComponent.prototype.shortEventKeyUp = function (event) {
        var val = event.target.value;
        this.shortEventDescCharCount = val.length;
    };
    EventAddFormComponent.prototype.getStates = function () {
        var COUNTRY = this.addEventForm.value.country;
        var resultArry = [];
        if (COUNTRY === 'US') {
            resultArry = eventUSStates;
        }
        else if (COUNTRY === 'CA') {
            resultArry = eventCanadianProvinces;
        }
        return resultArry;
    };
    EventAddFormComponent.prototype.statesFieldChanged = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.addEventForm.patchValue({ stateProvince: '' });
                        this.addEventForm.patchValue({ city: '' });
                        this.addEventForm.patchValue({ zipcode: '' });
                        this.addEventForm.patchValue({ address3: '' });
                        this.addEventForm.patchValue({ internationalAirportId: '' });
                        this.addEventForm.patchValue({ internationalAirportName: '' });
                        this.addEventForm.patchValue({ airport: '' });
                        this.addEventForm.patchValue({ overrideAddressLookup: false });
                        this.selectedAirport = null;
                        if (['US', 'CA'].includes(this.addEventForm.value.country)) {
                            this.addEventForm.controls['city'].setValidators(Validators.required);
                            this.addEventForm.controls['stateProvince'].setValidators(Validators.required);
                            this.addEventForm.controls['zipcode'].setValidators(Validators.required);
                        }
                        else {
                            this.addEventForm.controls['city'].setValidators([]);
                            this.addEventForm.controls['stateProvince'].setValidators([]);
                            this.addEventForm.controls['zipcode'].setValidators([]);
                        }
                        this._updateLatLngValidators();
                        this.addEventForm.controls['city'].updateValueAndValidity();
                        this.addEventForm.controls['stateProvince'].updateValueAndValidity();
                        this.addEventForm.controls['zipcode'].updateValueAndValidity();
                        this.currentCountry = event.source.triggerValue;
                        return [4 /*yield*/, this.updateTimeZones(event.value)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EventAddFormComponent.prototype.overrideAddressLookupChanged = function () {
        this._updateLatLngValidators();
    };
    EventAddFormComponent.prototype._updateLatLngValidators = function () {
        if (this.showLatLng()) {
            this.addEventForm.controls['latitude'].setValidators([Validators.required, Validators.min(-90), Validators.max(90),
                Validators.pattern('^-?\\d+[.]\\d+$')]);
            this.addEventForm.controls['longitude'].setValidators([Validators.required, Validators.min(-180), Validators.max(180),
                Validators.pattern('^-?\\d+[.]\\d+$')]);
        }
        else {
            this.addEventForm.controls['latitude'].setValidators([]);
            this.addEventForm.controls['longitude'].setValidators([]);
        }
        this.addEventForm.controls['latitude'].updateValueAndValidity();
        this.addEventForm.controls['longitude'].updateValueAndValidity();
    };
    EventAddFormComponent.prototype.updateTimeZones = function (countryCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(countryCode === 'US')) return [3 /*break*/, 1];
                        this.timezones = USTimezones;
                        this.addEventForm.patchValue({ timezone: '' });
                        return [3 /*break*/, 3];
                    case 1:
                        _a = this;
                        return [4 /*yield*/, this._aviationEventsService.getTimezones(countryCode)];
                    case 2:
                        _a.timezones = _b.sent();
                        if (this.timezones.length === 1) {
                            this.addEventForm.patchValue({ timezone: this.timezones[0].zoneName });
                        }
                        else {
                            this.addEventForm.patchValue({ timezone: '' });
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EventAddFormComponent.prototype.airportChange = function (airport) {
        this.selectedAirport = airport;
        this.airportSelectionError = false;
    };
    EventAddFormComponent.prototype.airportSearchFocusOut = function (event) {
        if (this.selectedAirport) {
            this.addEventForm.patchValue({ airport: this.selectedAirport.identifier + ": " + this.selectedAirport.name });
        }
        else {
            this.addEventForm.patchValue({ airport: '' });
        }
    };
    EventAddFormComponent.prototype.eventFormatSelectionChange = function (event) {
        var format = event.value;
        if (format === 'Online') {
            this._setAddressValidation(false);
            this.showAddressFields = false;
            this.addEventForm.patchValue({ address1: '' });
            this.addEventForm.patchValue({ address2: '' });
            this.addEventForm.patchValue({ address3: '' });
            this.addEventForm.patchValue({ city: '' });
            this.addEventForm.patchValue({ state: '' });
            this.addEventForm.patchValue({ zipcode: '' });
            this.addEventForm.patchValue({ internationalAirportId: '' });
            this.addEventForm.patchValue({ internationalAirportName: '' });
            this.addEventForm.patchValue({ latitude: '' });
            this.addEventForm.patchValue({ longitude: '' });
            this.addEventForm.patchValue({ overrideAddressLookup: false });
            this.addEventForm.controls['latitude'].setValidators([]);
            this.addEventForm.controls['longitude'].setValidators([]);
            this.addEventForm.controls['latitude'].updateValueAndValidity();
            this.addEventForm.controls['longitude'].updateValueAndValidity();
        }
        else {
            this._setAddressValidation();
            // this.addEventForm.patchValue({country: 'US'});
            this.showAddressFields = true;
        }
    };
    EventAddFormComponent.prototype._setAddressValidation = function (validationIsRequired) {
        if (validationIsRequired === void 0) { validationIsRequired = true; }
        this.addEventForm.removeControl('address1');
        this.addEventForm.removeControl('stateProvince');
        this.addEventForm.removeControl('city');
        this.addEventForm.removeControl('zipcode');
        // this.addEventForm.removeControl('country');
        this.addEventForm.removeControl('venueLocationName');
        if (validationIsRequired) {
            this.addEventForm.addControl('address1', new FormControl('', Validators.required));
            if (['US', 'CA'].includes(this.addEventForm.value.country)) {
                this.addEventForm.addControl('stateProvince', new FormControl('', Validators.required));
                this.addEventForm.addControl('city', new FormControl('', Validators.required));
                this.addEventForm.addControl('zipcode', new FormControl('', Validators.required));
            }
            else {
                this.addEventForm.addControl('stateProvince', new FormControl('', Validators.nullValidator));
                this.addEventForm.addControl('city', new FormControl('', Validators.nullValidator));
                this.addEventForm.addControl('zipcode', new FormControl('', Validators.nullValidator));
            }
            if (this.showLatLng()) {
                this.addEventForm.addControl('latitude', new FormControl('', [Validators.required,
                    Validators.min(-90), Validators.max(90), Validators.pattern('^-?\\d+[.]\\d+$')]));
                this.addEventForm.addControl('longitude', new FormControl('', [Validators.required,
                    Validators.min(-180), Validators.max(180), Validators.pattern('^-?\\d+[.]\\d+$')]));
            }
            else {
                this.addEventForm.addControl('latitude', new FormControl('', Validators.nullValidator));
                this.addEventForm.addControl('longitude', new FormControl('', Validators.nullValidator));
            }
            // this.addEventForm.addControl('country', new FormControl('', Validators.required));
            this.addEventForm.addControl('venueLocationName', new FormControl('', Validators.required));
        }
        else {
            this.addEventForm.addControl('address1', new FormControl('', Validators.nullValidator));
            this.addEventForm.addControl('stateProvince', new FormControl('', Validators.nullValidator));
            this.addEventForm.addControl('city', new FormControl('', Validators.nullValidator));
            this.addEventForm.addControl('zipcode', new FormControl('', Validators.nullValidator));
            // this.addEventForm.addControl('country', new FormControl('', Validators.nullValidator));
            this.addEventForm.addControl('venueLocationName', new FormControl('', Validators.nullValidator));
        }
    };
    return EventAddFormComponent;
}());
export { EventAddFormComponent };
